import {
  CellphoneNotFoundError,
  UnexpectedError,
} from "../../../domain/errors";
import { CellphoneAlreadyRegisteredError } from "../../../domain/errors/cellphone-already-exists-error";
import { AddCellphones } from "../../../domain/usecases/add-cellphones";
import { HttpClient, HttpStatusCode } from "../../protocols/http";

export class RemoteAddCellphones implements AddCellphones {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<void>
  ) {}

  async add(params: AddCellphones.Params): Promise<void> {
    console.log("AddCellphones.Params", params);
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body!;
      case HttpStatusCode.notFound:
        throw new CellphoneNotFoundError();
      case HttpStatusCode.conflict:
        throw new CellphoneAlreadyRegisteredError();
      default:
        throw new UnexpectedError();
    }
  }
}

// export namespace RemoteAddAccount {
//   export type Model = CreateUser.Model;
// }
